class StickyAddToCart extends HTMLElement {
    constructor() {
        super();

        this.layout_type = this.querySelector("sticky-add-to-cart-content")?.getAttribute("layout-type");
        this.drawerType = this.querySelector("[drawer-to-open]") ? this.querySelector("[drawer-to-open]").getAttribute("drawer-to-open") : "sticky-add-to-cart-drawer";
        this.variantList = this.querySelector("[sticky-add-to-cart-variants]");

        // 【核心修复1】删除固定缓存的按钮变量，改为每次动作时动态获取，防止 DOM 刷新后选中“已死”的元素

        document.addEventListener(_EVENT_HELPER.updateStickyAddToCartContent, this._updateStickyAddToCartContent.bind(this));
        document.addEventListener(_EVENT_HELPER.updateStickyAddToCartContentUnAvailable, this._updateStickyAddToCartContentUnAvailable.bind(this));

        // 事件委托：拦截 Buy Now 点击
        this.addEventListener('click', (e) => {
            const buyNowBtn = e.target.closest('#customDirectBuyNowBtn');
            if (!buyNowBtn) return;

            e.preventDefault();
            e.stopImmediatePropagation();

            const formId = buyNowBtn.getAttribute('form') || "{{ form_id }}";
            const form = document.getElementById(formId) || buyNowBtn.closest('form') || document.querySelector('form[action*="/cart/add"]');
            
            let variantId = buyNowBtn.getAttribute('data-variant-id');
            let quantity = 1;

            if (form) {
                const variantInput = form.querySelector('[name="id"]');
                if (variantInput && variantInput.value) {
                    variantId = variantInput.value;
                }
                const quantityInput = form.querySelector('[name="quantity"]');
                if (quantityInput && quantityInput.value) {
                    quantity = quantityInput.value;
                }
            }

            // Buy Now 点击后进入丝滑 Loading 转圈状态
            buyNowBtn.classList.add('is-loading');
            buyNowBtn.style.opacity = '0.9';
            buyNowBtn.style.pointerEvents = 'none';

            // 【核心修复2】加入超时解锁，防止网络延迟或浏览器后退导致按钮永久卡死
            setTimeout(() => {
                buyNowBtn.classList.remove('is-loading');
                buyNowBtn.style.opacity = '1';
                buyNowBtn.style.pointerEvents = 'auto';
            }, 3000); // 3秒后无论是否跳转成功，强制解除禁用状态

            // 直达结账页
            window.location.href = `/cart/add?id=${variantId}&quantity=${quantity}&return_to=/checkout`;
        });
    }

    _updateStickyAddToCartContent(e) {
        let content_list = e.detail.sticky_content
        content_list.forEach(element => {
            let stickyElement = element.querySelector("sticky-add-to-cart-content")
            if (stickyElement && stickyElement.getAttribute("layout-type") === this.layout_type) {
                let targetContainer = this.querySelector("[sticky-add-to-cart-content]");
                if (targetContainer) {
                    targetContainer.innerHTML = element.innerHTML;
                    // 内容更新后，主动触发一次价格样式的转换
                    const contentComponent = targetContainer.querySelector("sticky-add-to-cart-content");
                    if (contentComponent && typeof contentComponent._applyCustomFinalPrice === 'function') {
                        contentComponent._applyCustomFinalPrice();
                    }
                }
            }
        });
    }

    _updateStickyAddToCartContentUnAvailable(e) {
        if (this.variantList) {
            this.variantList.textContent = e.detail.variantOptions.join(", ");
        }
        this.togleAddToCartButton(false)
    }

    disconnectedCallback() {
        document.removeEventListener(_EVENT_HELPER.updateStickyAddToCartContent, this._updateStickyAddToCartContent.bind(this));
        document.removeEventListener(_EVENT_HELPER.updateStickyAddToCartContentUnAvailable, this._updateStickyAddToCartContentUnAvailable.bind(this));
    }

    togleAddToCartButton(buttonEnabled) {
        // 【核心修复3】每次切换变体时，动态重新获取所有的加购按钮，确保即使 HTML 被刷新也能准确控制
        const currentButtons = this.querySelectorAll("[add-to-cart-button]");
        if (currentButtons.length > 0) {
            currentButtons.forEach(btn => {
                if (buttonEnabled) {
                    btn.removeAttribute("disabled")
                } else {
                    if (!btn.classList.contains("sticky-icon-button") && !btn.classList.contains("custom-atc-mob")) {
                        btn.textContent = window.variantStrings.unavailable
                    }
                    btn.removeAttribute("form")
                    btn.setAttribute("disabled", true);
                }
            });
        }
    }
}
window.customElements.define('sticky-add-to-cart', StickyAddToCart);


class StickyAddToCartContent extends HTMLElement {
    constructor() {
        super();
        this.buttonContainer = this.querySelector("[stikcy-add-to-cart-button-content]")
        
        // 【核心修复4】使用事件委托处理加购点击！绑定在组件自身上，无视子元素的刷新覆写
        this.addEventListener("click", (e) => {
            const btn = e.target.closest("[add-to-cart-button]");
            if (!btn) return;
            
            btn.classList.add('is-loading');
            btn.classList.remove('is-success');
            
            HELPER_UTIL.submitButtonState(btn).loadingState();
            HELPER_UTIL.dispatchCustomEvent('submit', document.getElementById(btn.getAttribute('form')));
        });

        this._product_container = document.querySelector('[product-container]');
        this._drawerScrollToSection = document.querySelector("drawer-component [scroll-to-section]")
        this._scrollToSectionButton = this.querySelector("[scroll-to-section]")

        this.breakpoint = window.matchMedia('(min-width:768px)');
        
        document.addEventListener(_EVENT_HELPER.resetStickyAddTocartButton, (e) => {
            // 【核心修复5】每次主题触发完成事件时，重新获取当前 DOM 里最新的按钮，然后为其播放打勾动画
            const currentButtons = this.querySelectorAll("[add-to-cart-button]");
            currentButtons.forEach(btn => {
                HELPER_UTIL.submitButtonState(btn).resetState(1000);
                HELPER_UTIL.submitButtonState(btn).disableState(false);
                
                // 加购成功后展示丝滑的 Success 动画
                btn.classList.remove('is-loading');
                btn.classList.add('is-success');
                
                // 2秒后恢复原状，以便用户再次点击
                setTimeout(() => {
                    btn.classList.remove('is-success');
                }, 2000);
            });
        });
        
        document.addEventListener('scroll', this._scrollHandler.bind(this));
        window.addEventListener('resize', this.screenResize.bind(this));
        document.addEventListener(_EVENT_HELPER.triggerVariantAddToCartError, (e) => {
            this.componentState = this.closest("sticky-add-to-cart").getAttribute("aria-hidden")
            if (this.componentState === "false") {
                this._scrollToSection(e)
            }
        });
        this._scrollToSectionButton?.addEventListener("click", this._scrollToSection.bind(this))
        this._drawerScrollToSection && this._drawerScrollToSection.addEventListener("click", this._scrollToSection.bind(this))
        this.scrollTosection = this._scrollToSectionButton?.getAttribute("scroll-to-section") || this._drawerScrollToSection?.getAttribute("scroll-to-section");
        this.scrollTosectionElement = document.querySelector(`#shopify-section-${this.scrollTosection} [variant-block]`)
    }

    connectedCallback() {
        if (this._product_container) {
            this._product_containerOffsetTop = this._product_container.offsetTop;
            this._product_containerHeight = this._product_container.offsetHeight;
            this._totalScrollHeight = this._product_containerOffsetTop + this._product_containerHeight;
        }
        this.screenResize();
        this._applyCustomFinalPrice();
    }

    _applyCustomFinalPrice() {
        const priceWrapper = this.querySelector('.price, .product-price__wrapper, .stikcy-price');
        if (!priceWrapper) return;

        const finalPriceVal = priceWrapper.getAttribute('data-final-price');
        if (!finalPriceVal || finalPriceVal.trim() === '') return;

        if (priceWrapper.classList.contains('custom-final-price-applied')) return;

        const regularPriceElem = priceWrapper.querySelector('.price-item--regular, .price__regular, .money, .price');
        if (!regularPriceElem) return;

        priceWrapper.classList.add('custom-final-price-applied');

        regularPriceElem.style.textDecoration = 'line-through';
        regularPriceElem.style.color = 'rgba(var(--color-foreground, 0,0,0), 0.6)';
        regularPriceElem.style.marginRight = '8px';
        regularPriceElem.style.fontSize = '0.9em';

        const finalPriceElem = document.createElement('span');
        finalPriceElem.className = 'price-item price-item--sale custom-highlight-price';
        finalPriceElem.style.color = '#ff4b4b';
        finalPriceElem.style.fontWeight = '700';
        finalPriceElem.innerHTML = finalPriceVal;

        regularPriceElem.parentNode.insertBefore(finalPriceElem, regularPriceElem);
    }

    _scrollToSection(e) {
        e.preventDefault()

        HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.hideDrawer, this, {
            drawerType: this.drawerType,
        });
        this.scrollTosectionElementOffset > 0 &&
            window.scrollTo({
                top: this.scrollTosectionElementOffset,
                behavior: 'smooth'
            })
    }

    screenResize() {
        if (this.breakpoint.matches === true) {
            this.scrollTosectionElementOffset = (this.scrollTosectionElement && this._product_container) ? this.scrollTosectionElement?.offsetTop + this._product_container?.offsetTop : 0
        } else {
            const scrollProductInfo = document.querySelector("[scroll-product-info]");
            this.scrollTosectionElementOffset = (this.scrollTosectionElement && scrollProductInfo) ? scrollProductInfo?.offsetTop + this.scrollTosectionElement?.offsetTop : 0
        }
    }

    _scrollHandler() {
        if (this._totalScrollHeight && window.scrollY > this._totalScrollHeight) {
            this.closest("sticky-add-to-cart")?.classList.add("active")
        } else {
            this.closest("sticky-add-to-cart")?.classList.remove("active")
        }
    }

    disconnectedCallback() {
        document.removeEventListener('scroll', this._scrollHandler.bind(this));
        this._scrollToSectionButton && this._scrollToSectionButton.removeEventListener("click", this._scrollToSection.bind(this))
        this._drawerScrollToSection && this._drawerScrollToSection.removeEventListener("click", this._scrollToSection.bind(this))
    }
}
window.customElements.define('sticky-add-to-cart-content', StickyAddToCartContent);


// 【核心修复6】终极保险：监听页面由于“后退按钮”重新展示时，清除所有结账按钮的禁用状态
window.addEventListener('pageshow', function (event) {
    if (event.persisted) { // 如果页面是从浏览器缓存中恢复的
        document.querySelectorAll('#customDirectBuyNowBtn').forEach(btn => {
            btn.classList.remove('is-loading');
            btn.style.opacity = '1';
            btn.style.pointerEvents = 'auto';
        });
    }
});